import { Component, Input } from '@angular/core';
import { IconService } from '../../../services/icon.service';

@Component({
  selector: 'app-portal-links',
  templateUrl: './portal-links.component.html',
  styleUrls: ['./portal-links.component.scss']
})
export class PortalLinksComponent {
  constructor(private iconService: IconService){}
  @Input() data: any;
  ngOnInit(): void{
    this.iconService.addIconToRegistry({
      key: this.data.icon,
      path: this.data.icon
    });
  }
}
